import { render, staticRenderFns } from "./MealsTable.vue?vue&type=template&id=45e2772b"
import script from "./MealsTable.vue?vue&type=script&lang=js"
export * from "./MealsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports